// mutations of the state happens here
import { addDataToSession } from '@attensi/session'
import * as types from './mutation-types'

/** Check if loading variables are set to 'true'.
 *  If all resources are loaded, set 'allResources
 * @param {Object} state
 */
const checkAllResourcesLoaded = (state) => {
  state.allResourcesLoaded = [
    'currentCompanyLoaded',
    'currentUserLoaded',
    'countryCodesLoaded',
    'userCompaniesLoaded',
  ].every((key) => state[key])
}

export default {
  [types.FETCH_CURRENTUSER_PENDING](state) {
    state.currentUserLoading = true
  },
  [types.FETCH_COMPANYDATA_PENDING](state) {
    state.currentCompanyLoading = true
  },
  [types.FETCH_CURRENTUSER_SUCCESS](state) {
    state.currentUserLoading = false
  },
  [types.FETCH_COMPANYDATA_SUCCESS](state) {
    state.currentCompanyLoading = false
  },
  [types.FETCH_CURRENTUSER_FAILURE](state) {
    state.currentUserLoading = false
  },
  [types.FETCH_COMPANYDATA_FAILURE](state) {
    state.currentCompanyLoading = false
  },
  [types.LOAD_CURRENTUSER](state, currentUser) {
    state.currentUser = currentUser
    state.currentUserLoaded = true
    checkAllResourcesLoaded(state)
  },
  async [types.LOAD_COMPANYDATA](state, currentCompany) {
    state.currentCompany = currentCompany
    // Link to docs on package
    await addDataToSession(
      currentCompany.attensi_com_subdomain,
      'name',
      currentCompany.name
    )
    await addDataToSession(
      currentCompany.attensi_com_subdomain,
      'logo_url',
      currentCompany.logo
    )
    state.currentCompanyLoaded = true
    checkAllResourcesLoaded(state)
  },

  [types.LOAD_COUNTRYCODES](state, countryCodes) {
    state.countryCodes = countryCodes
    state.countryCodesLoaded = true
    checkAllResourcesLoaded(state)
  },
  [types.LOAD_POSITIONS](state, companyPositions) {
    state.companyPositions = companyPositions
    state.companyPositionsLoaded = true
  },
  [types.LOAD_GROUPS](state, companyGroups) {
    state.companyGroups = companyGroups
    state.companyGroupsLoaded = true
  },
  [types.LOAD_CURRENTUSER_COMPANIES](state, userCompanies) {
    state.userCompanies = userCompanies
    state.userCompaniesLoaded = true
    checkAllResourcesLoaded(state)
  },
  [types.LOAD_CURRENTUSER_DEPARTMENTS](state, userDepartments) {
    state.userDepartments = userDepartments
  },
  [types.PATCH_CURRENTUSER_DEPARTMENTS](state, userDepartments) {
    state.userDepartments = [...state.userDepartments, ...userDepartments]
  },
  [types.RESET_CACHED_USERDEPARTMENTS](state) {
    state.userDepartments = []
  },
  [types.TRIGGER_CONTENT_LOCALE_UPDATE](state) {
    // Update timestamp to force contentLocale getter re-computation
    state.contentLocaleTimestamp = Date.now()
  },
}
